/**
 * API base URL for the bot-worker.
 *
 * - In dev, leave empty so Vite's proxy forwards /api and /storage to the
 *   local server or worker (see vite.config.ts).
 * - In prod (Pages), set VITE_API_BASE to the deployed worker URL, e.g.
 *   https://pastabot.<account>.workers.dev
 */
export const API_BASE: string = (import.meta.env?.VITE_API_BASE ?? '').replace(/\/+$/, '');

export function apiUrl(path: string): string {
    if (!path.startsWith('/')) path = '/' + path;
    return `${API_BASE}${path}`;
}
